import Events from 'event-pubsub/es6'

export default new Events()
